export default __webpack_public_path__ + "static/media/ic-drillup.04b0f8ef.svg";